module.exports = __webpack_public_path__ + "img/com-test-main-image.c77e64fe.svg";